
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.082 16.078"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.042 3.917a4.122 4.122 0 104.122 4.122 4.116 4.116 0 00-4.122-4.122zm0 6.8a2.68 2.68 0 112.68-2.68 2.685 2.685 0 01-2.68 2.68zm5.253-6.969a.962.962 0 11-.962-.962.959.959 0 01.962.962zm2.73.976a4.758 4.758 0 00-1.3-3.369 4.79 4.79 0 00-3.369-1.3C10.029-.02 6.05-.02 4.722.055a4.783 4.783 0 00-3.369 1.3 4.774 4.774 0 00-1.3 3.369c-.075 1.327-.075 5.306 0 6.634a4.758 4.758 0 001.3 3.369 4.8 4.8 0 003.369 1.3c1.327.075 5.306.075 6.634 0a4.758 4.758 0 003.369-1.3 4.79 4.79 0 001.3-3.369c.075-1.327.075-5.3 0-6.63zm-1.715 8.054a2.713 2.713 0 01-1.528 1.528c-1.058.42-3.57.323-4.739.323s-3.685.093-4.739-.323a2.713 2.713 0 01-1.529-1.528c-.42-1.058-.323-3.57-.323-4.739s-.093-3.685.323-4.739a2.713 2.713 0 011.53-1.529c1.058-.42 3.57-.323 4.739-.323s3.685-.093 4.739.323a2.713 2.713 0 011.528 1.528c.42 1.058.323 3.57.323 4.739s.096 3.685-.324 4.74z"}})])
          )
        }
      }
    